import { ILoadableArray, Loadable, createDefaultILoadableArray, createDefaultLoadable } from '../../common/models/loadable';
import { AlertReportComponentType, AlertReportTemplate } from '../models/alert-report-template.model';

export interface AlertReportTemplateState {
  templates: ILoadableArray<AlertReportTemplate>;
  componentTypes: ILoadableArray<AlertReportComponentType>;
  create: Loadable & { template: AlertReportTemplate | null };
  delete: Loadable;
  preview: Loadable & { html: string | null };
  generate: Loadable;
  notify: Loadable;
  export: Loadable;
}

export const initialAlertReportTemplateState: AlertReportTemplateState = {
  templates: createDefaultILoadableArray<AlertReportTemplate>(),
  componentTypes: createDefaultILoadableArray<AlertReportComponentType>(),
  create: { ...createDefaultLoadable(), template: null },
  delete: createDefaultLoadable(),
  preview: { ...createDefaultLoadable(), html: null },
  generate: createDefaultLoadable(),
  notify: createDefaultLoadable(),
  export: createDefaultLoadable()
};
